<template>
  <div class="riesgo">
    <div>
      <div>
        <h4>{{ $t("DATOS DEL RIESGO") }}</h4>
        <el-form>
          <el-row :gutter="20">
            <el-col :span="14">
              <el-form-item :label="$t('Nombre del Riesgo')">
                <el-input
                  v-if="editable"
                  v-model="risk.nombre"
                  placeholder="Nombre del riesgo"
                />
                <div v-else>
                  <br />
                  {{ risk.nombre }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('Tipo de Impacto')" :key="render">
                <br />
                <el-button-group>
                  <el-button
                    type="info"
                    :plain="risk.tipo && risk.tipo.toLowerCase() !== 'salud'"
                    @click="setTypeRisk('salud')"
                  >
                    <b>Salud</b>
                  </el-button>
                  <el-button
                    type="info"
                    :plain="
                      risk.tipo && risk.tipo.toLowerCase() !== 'seguridad'
                    "
                    @click="setTypeRisk('seguridad')"
                  >
                    <b>Seguridad</b>
                  </el-button>
                  <el-button
                    type="info"
                    :plain="
                      risk.tipo && risk.tipo.toLowerCase() !== 'medioambiente'
                    "
                    @click="setTypeRisk('medioambiente')"
                  >
                    <b>Medioambiente</b>
                  </el-button>
                </el-button-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div v-if="risk.tipo && risk.tipo.toLowerCase() === 'medioambiente'">
        <hr
          class="separacion"
          v-if="risk.tipo && risk.tipo.toLowerCase() === 'medioambiente'"
        />
        <h4>{{ $t("INFORMACIÓN MEDIOAMBIENTAL") }}</h4>
        <el-form>
          <el-row :gutter="20">
            <el-col :md="12">
              <el-form-item>
                <div>
                  {{ $t('Responsable') }}
                  <el-popover
                    class="help-box"
                    placement="top"
                    :title="$t('Responsable')"
                    width="200"
                    trigger="hover"
                    :content="
                      $t(`Principal fuente que genera que ocurra un riesgo o aspecto medioambiental.`)
                    "
                  >
                    <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </div>
                <el-input
                  v-model="risk.medioambiente.responsable"
                  type="text"
                  :placeholder="$t('Ingrese responsable')"
                  v-if="editable"
                ></el-input>
                <div v-else>{{ risk.medioambiente.responsable || "N/A" }}</div>
              </el-form-item>
              <el-form-item>
                <div>
                  {{ $t('Condición') }}
                  <el-popover
                    class="help-box"
                    placement="top"
                    :title="$t('Condición')"
                    width="200"
                    trigger="hover"
                    :content="
                      $t(`Es el tipo de condición o contexto en el que se genera el riesgo o aspecto de tipo medioambiental.`)
                    "
                  >
                    <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </div>
                <el-select
                  v-model="risk.medioambiente.condicion"
                  v-if="editable"
                  :placeholder="$t('Seleccione condicion')"
                  class="full-width"
                >
                  <el-option
                    v-for="item in optionsCondicion"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <div v-else>{{ risk.medioambiente.condicion || "N/A" }}</div>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item>
                <div>
                  {{ $t('Evento') }}
                  <el-popover
                    class="help-box"
                    placement="top"
                    :title="$t('Evento')"
                    width="200"
                    trigger="hover"
                    :content="
                      $t(`Es el incidente que ocurre en el espacio de trabajo generando el riesgo/aspecto medioambiental.`)
                    "
                  >
                    <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </div>
                <el-input
                  v-model="risk.medioambiente.evento"
                  type="text"
                  :placeholder="$t('Ingrese evento')"
                  v-if="editable"
                ></el-input>
                <div v-else>{{ risk.medioambiente.evento || "N/A" }}</div>
              </el-form-item>
              <el-form-item>
                <div>
                  {{ $t('Equipo Crítico') }}
                  <el-popover
                    class="help-box"
                    placement="top"
                    :title="$t('Equipo Crítico')"
                    width="200"
                    trigger="hover"
                    :content="
                      $t(`Equipo con el que se cuenta a disposición para controlar (mitigar) el evento no deseado.`)
                    "
                  >
                    <i slot="reference" class="el-icon-question"></i>
                  </el-popover>
                </div>
                <el-input
                  v-model="risk.medioambiente.equipo"
                  type="text"
                  :placeholder="$t('Ingrese equipo')"
                  v-if="editable"
                ></el-input>
                <div v-else>{{ risk.medioambiente.equipo || "N/A" }}</div>
              </el-form-item>
              <el-form-item
                :label="$t('Evaluación Aspecto Ambiental')"
                v-if="!editable"
              >
                <el-tag
                  :type="getFactores(risk)[0].mfl >= 3 ? 'danger' : 'success'"
                  >{{
                    getFactores(risk)[0].mfl >= 3
                      ? $t("Significativo")
                      : $t("No Significativo")
                  }}</el-tag
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <hr class="separacion" />
      <div>
        <el-row :gutter="30">
          <el-col :md="24">
            <el-col :md="24" v-if="risk.escenario">
              <br />
              <h4 class="margin-title">
                {{ $t("ESCENARIO") }}
                <el-popover
                  class="help-box"
                  placement="top"
                  :title="$t('Escenario')"
                  width="200"
                  trigger="hover"
                  :content="
                    $t(
                      'En este recuadro debe introducir dos tipos de escenario: Escenario Residual, que corresponde a aquel en donde el control es efectivo, y Escenario MFL, que corresponde a aquel en donde el control es inefectivo.'
                    )
                  "
                >
                  <i slot="reference" class="el-icon-question"></i>
                </el-popover>
              </h4>
              <el-input
                v-model="risk.escenario"
                v-if="editable"
                type="textarea"
                :rows="6"
                :placeholder="$t('Ingrese descripción de escenario')"
              />
              <p v-else>{{ risk.escenario || $t("No ingresado") }}</p>
              <br />
              <br />
            </el-col>
            <el-col :md="12">
              <br />
              <h4 class="margin-title">
                {{ $t("ESCENARIO RESIDUAL") }}
                <el-popover
                  class="help-box"
                  placement="top"
                  :title="$t('Escenario Residual')"
                  width="200"
                  trigger="hover"
                  :content="
                    $t(`Corresponde a la descripción del evento de riesgo que se
                    está analizando considerando que los controles preventivos son efectivos.`)
                  "
                >
                  <i slot="reference" class="el-icon-question"></i>
                </el-popover>
              </h4>
              <el-input
                v-model="risk.escenario_residual"
                v-if="editable"
                type="textarea"
                :rows="6"
                :placeholder="$t('Ingrese descripción de escenario')"
              />
              <p v-else>{{ risk.escenario_residual || $t("No ingresado") }}</p>
              <br />
              <br />
            </el-col>
            <el-col :md="12">
              <br />
              <h4 class="margin-title">
                {{ $t("ESCENARIO MFL") }}
                <el-popover
                  class="help-box"
                  placement="top"
                  :title="$t('Escenario')"
                  width="200"
                  trigger="hover"
                  :content="
                    $t(`Corresponde a la descripción del evento de riesgo que se está
                  analizando considerando que los controles preventivos son inefectivos o
                  inexistentes.`)
                  "
                >
                  <i slot="reference" class="el-icon-question"></i>
                </el-popover>
              </h4>
              <el-input
                v-model="risk.escenario_mfl"
                v-if="editable"
                type="textarea"
                :rows="6"
                :placeholder="$t('Ingrese descripción de escenario')"
              />
              <p v-else>{{ risk.escenario_mfl || $t("No ingresado") }}</p>
              <br />
              <br />
            </el-col>
          </el-col>
          <!-- <el-col :md="10">
            <br />
            <h4
              class="izquierda margin-title"
            >{{ $t('PERSONAS QUE PARTICIPAN EN EL ANÁLISIS DEL RIESGO') }}</h4>
            <el-button
              v-if="editable"
              icon="el-icon-plus"
              class="derecha"
              type="primary"
              size="mini"
              @click="dialogNewEvaluadorVisible = true"
            >
              <b>{{ $t('Añadir Participante') }}</b>
            </el-button>
            <el-table
              :data="risk.evaluadores"
              row-class-name="rowClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray"
            >
              <el-table-column :label="$t('Nombre')" prop="nombre"></el-table-column>
              <el-table-column :label="$t('RUT')" prop="rut"></el-table-column>
              <el-table-column :label="$t('Cargo')" prop="cargo" />
              <el-table-column v-if="editable" align="center" header-align="center" width="125">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    @click="editDialogEvaluador(scope.row)"
                    icon="el-icon-edit"
                  />
                  <el-button
                    type="danger"
                    size="small"
                    @click="deleteEvaluador(scope.row)"
                    icon="el-icon-delete"
                  />
                </template>
              </el-table-column>
            </el-table>
            <br />
          </el-col> -->
        </el-row>
      </div>
      <hr class="separacion" />
      <div>
        <el-row :gutter="20">
          <!-- Causas -->
          <el-col :md="10">
            <br />
            <h4 class="izquierda margin-title">
              {{ $t("CAUSAS") }}
              <el-popover
                class="help-box"
                placement="top"
                :title="$t('Causas')"
                width="200"
                trigger="hover"
                :content="
                  $t(
                    'Las causas son las circunstancias que pueden gatillar la ocurrencia del evento.'
                  )
                "
              >
                <i slot="reference" class="el-icon-question" />
              </el-popover>
            </h4>
            <el-button
              v-if="editable"
              icon="el-icon-plus"
              type="primary"
              size="mini"
              class="derecha"
              @click="dialogNewCausaVisible = true"
            >
              <b>{{ $t("Añadir Causa") }}</b>
            </el-button>
            <el-table
              :data="risk.causas"
              style="width: 100%"
              row-class-name="rowClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray"
            >
              <el-table-column prop="id" label="ID" width="80">
                <template slot-scope="scope"
                  >CA{{ risk.causas.indexOf(scope.row) + 1 }}</template
                >
              </el-table-column>
              <el-table-column prop="nombre" :label="$t('Nombre')" />
              <el-table-column
                v-if="editable"
                align="center"
                header-align="center"
                width="125"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    @click="editDialogCausa(scope.row)"
                    icon="el-icon-edit"
                  ></el-button>
                  <el-button
                    type="danger"
                    size="small"
                    @click="deleteCausa(scope.row)"
                    icon="el-icon-delete"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
            <br />
          </el-col>
          <!-- Riesgo -->
          <el-col :md="4">
            <!-- COLORES
              Material rojo
              No material amarillo
            Custom celeste-->
            <!-- Riesgo Material creado por MEL desde admin -->
            <div
              v-if="risk.tipo && risk.tipo.toLowerCase() === 'salud'"
              class="colorSalud customRiskBox"
            >
              {{ risk.nombre === "" ? "Sin nombre" : risk.nombre }}
            </div>
            <!-- Riesgo No Material creado por MEL desde admin -->
            <div
              v-if="risk.tipo && risk.tipo.toLowerCase() === 'seguridad'"
              class="colorSeguridad customRiskBox"
            >
              {{ risk.nombre === "" ? "Sin nombre" : risk.nombre }}
            </div>
            <!-- Riesgo Personalizado -->
            <div
              v-if="
                risk.tipo &&
                (risk.tipo.toLowerCase() === 'medioambiental' ||
                  risk.tipo.toLowerCase() === 'medioambiente')
              "
              class="colorMedioambiental customRiskBox"
            >
              {{ risk.nombre === "" ? "Sin nombre" : risk.nombre }}
            </div>
            <!-- Riesgo Sin tipo -->
            <div v-if="!risk.tipo" class="colorWithoutRisk customRiskBox">
              {{ risk.nombre === "" ? "Sin nombre" : risk.nombre }}
            </div>
          </el-col>
          <!-- Impactos -->
          <el-col :md="10">
            <br />
            <h4 class="izquierda margin-title">
              {{ $t("IMPACTOS") }}
              <el-popover
                class="help-box"
                placement="top"
                :title="$t('Impactos')"
                width="200"
                trigger="hover"
                :content="$t(`Nivel de severidad cuando el evento ocurre.`)"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </h4>
            <el-button
              v-if="editable && risk.impactos < 1"
              icon="el-icon-plus"
              size="mini"
              type="primary"
              class="derecha"
              @click="dialogNewImpactoVisible = true"
              >{{ $t("Evaluar impacto") }}</el-button
            >
            <el-table
              :data="risk.impactos"
              style="width: 100%"
              row-class-name="rowClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray"
            >
              <el-table-column prop="id" label="ID" width="80">
                <template slot-scope="scope"
                  >IM{{ risk.impactos.indexOf(scope.row) + 1 }}</template
                >
              </el-table-column>
              <el-table-column
                prop="categoria"
                width="120"
                :label="$t('Tipo')"
              />
              <el-table-column prop="mfl" label="MFL" />
              <el-table-column prop="factor_severidad" label="FS" />
              <el-table-column prop="factor_probabilidad" label="FP" />
              <el-table-column prop="nivel_severidad" label="NSR" />
              <el-table-column
                v-if="editable"
                align="center"
                header-align="center"
                width="125"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    icon="el-icon-edit"
                    @click="editDialogImpacto(scope.row)"
                  />
                  <el-button
                    type="danger"
                    size="small"
                    icon="el-icon-delete"
                    @click="deleteImpacto(scope.row)"
                  />
                </template>
              </el-table-column>
            </el-table>
            <br />
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <!-- Controles Preventivos -->
          <el-col :md="10">
            <hr />
            <br />
            <h4 class="izquierda margin-title">
              {{ $t("CONTROLES PREVENTIVOS") }}
              <el-popover
                class="help-box"
                placement="top"
                :title="$t('Controles Preventivos')"
                width="200"
                trigger="hover"
                :content="
                  $t(`Los controles preventivos son los que se utilizan
                  para enfrentarse a las causas, por lo que reducen la
                  probabilidad de que ocurran riesgos.`)
                "
              >
                <i slot="reference" class="el-icon-question" />
              </el-popover>
            </h4>
            <el-button
              v-if="
                editable && risk.causas.length > 0 && risk.impactos.length > 0
              "
              icon="el-icon-plus"
              class="derecha"
              type="primary"
              size="mini"
              @click="dialogNewControlPreventivoVisible = true"
            >
              <b>{{ $t("Añadir Control Preventivo") }}</b>
            </el-button>
            <el-table
              :key="render"
              row-class-name="rowClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray"
              :data="getControlesPreventivos(risk)"
              style="width: 100%"
            >
              <el-table-column prop="nombre" :label="$t('Nombre')" />
              <el-table-column prop="id_causa" :label="$t('Causa')" width="90">
                <template slot-scope="scope">
                  <div v-for="causaHumanID in scope.row.causasHumanID">
                    {{ causaHumanID }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="editable"
                align="center"
                header-align="center"
                width="125"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    @click="editDialogControlPreventivo(scope.row)"
                    icon="el-icon-edit"
                  />
                  <el-button
                    type="danger"
                    size="small"
                    @click="deleteControlPreventivo(scope.row)"
                    icon="el-icon-delete"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <!-- Factores -->
          <el-col :md="4">
            <h4 class="align-center">{{ $t("FACTORES") }}</h4>
            <el-table
              :data="getFactores(risk)"
              style="width: 100%"
              class="factores"
            >
              <el-table-column prop="rrr" align="center" label="RRR">
                <template slot-scope="scope">
                  <el-tag class="factores">{{ scope.row.rrr }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="mfl" align="center" label="MFL">
                <template slot-scope="scope">
                  <el-tag
                    v-bind:type="mflRange(scope.row.mfl)"
                    class="factores"
                    hit
                    >{{ scope.row.mfl }}</el-tag
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <!-- Controles Mitigadores -->
          <el-col :md="10">
            <hr />
            <br />
            <h4 class="izquierda margin-title">
              {{ $t("CONTROLES MITIGADORES") }}
              <el-popover
                class="help-box"
                placement="top"
                title="Controles Mitigadores"
                width="200"
                trigger="hover"
                :content="
                  $t(`Los controles de mitigación son aquellos que
                  reducen los impactos derivados de un riesgo.`)
                "
              >
                <i slot="reference" class="el-icon-question" />
              </el-popover>
            </h4>
            <el-button
              v-if="
                editable &&
                risk.impactos.length > 0 &&
                validarControlMitigador(risk.impactos)
              "
              icon="el-icon-d-arrow-right"
              class="right button-skip"
              type="primary"
              size="mini"
              @click="skipControlMitigador(risk.impactos)"
            >
              <b>{{ $t("No Aplica") }}</b>
            </el-button>
            <el-button
              v-if="
                editable &&
                risk.impactos.length > 0 &&
                validarControlMitigador(risk.impactos)
              "
              icon="el-icon-plus"
              class="derecha"
              type="primary"
              size="mini"
              @click="openDialogControlMitigador"
            >
              <b>{{ $t("Añadir Control Mitigador") }}</b>
            </el-button>
            <el-table
              row-class-name="rowClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray"
              :data="getControlesMitigadores(risk)"
              style="width: 100%"
            >
              <el-table-column prop="nombre" :label="$t('Nombre')" />
              <el-table-column
                prop="id_impacto"
                :label="$t('Impacto')"
                width="90"
              />
              <el-table-column
                v-if="editable"
                align="center"
                header-align="center"
                width="125"
              >
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      scope.row.not_apply === false ||
                      scope.row.hasOwnProperty('not_apply') === false
                    "
                    size="small"
                    @click="editDialogControlMitigador(scope.row)"
                    icon="el-icon-edit"
                  />
                  <el-button
                    type="danger"
                    size="small"
                    @click="deleteControlMitigador(scope.row)"
                    icon="el-icon-delete"
                  />
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="this.$store.getters.role.admin === true">
          <el-col :sm="10">
            <br /><br />
            <h4 class="margin-title">
              {{ $t("CONTROLES NO CRÍTICOS") }}
            </h4>
            Ingrese nombre del control no crítico
            <br />
            <el-input
              v-model="control_no_critico"
              style="margin-top: 10px; width: 70%"
              size="medium"
            ></el-input>
            <el-button
              @click="addControlNoCritico()"
              type="primary"
              size="medium"
              icon="el-icon-plus"
              style="width: 120px; margin-left: 10px"
              >Agregar</el-button
            >
            <br /><br />
            <el-table
              row-class-name="rowClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray"
              :data="risk.controles_no_criticos"
              style="width: 100%"
            >
              <el-table-column prop="nombre" :label="$t('Nombre')" />
              <el-table-column
                label="Opciones"
                v-if="editable"
                align="center"
                header-align="center"
                width="125"
              >
                <template slot-scope="scope">
                  <el-button @click="deleteControlNoCritico(scope.row)" type="danger" size="small" icon="el-icon-delete" />
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </div>

    <el-dialog
      :before-close="handleClose"
      title="Evaluador"
      width="40%"
      append-to-body
      :visible="dialogNewEvaluadorVisible"
    >
      <center v-if="searchUser">
        <br />
        <br />
        <Circle9 style="margin-bottom: 8px"></Circle9>
        <small>Cargando Datos ...</small>
        <br />
        <br />
      </center>
      <el-form
        v-else
        :model="formEvaluador"
        label-position="top"
        :rules="rulesEvaluador"
        ref="formEvaluador"
      >
        <el-form-item label="RUT" prop="rut" :label-width="formLabelWidth">
          <el-input
            v-model="formEvaluador.rut"
            class="with-help-box"
            auto-complete="on"
          />
          <el-popover
            class="help-box"
            placement="right"
            title="RUT"
            width="200"
            trigger="hover"
            :content="$t('Escriba el RUT del evaluador')"
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item
          label="Nombre"
          prop="nombre"
          :label-width="formLabelWidth"
        >
          <el-input
            :disabled="inputNombreDisable === true || !formEvaluador.rut"
            v-model="formEvaluador.nombre"
            class="with-help-box"
            auto-complete="on"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Nombre')"
            width="200"
            trigger="hover"
            :content="$t('Escriba el Nombre del evaluador')"
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item label="Cargo" prop="cargo" :label-width="formLabelWidth">
          <el-input
            :disabled="inputCargoDisable === true || !formEvaluador.rut"
            v-model="formEvaluador.cargo"
            class="with-help-box"
            auto-complete="on"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Cargo')"
            width="200"
            trigger="hover"
            :content="
              $t('Escriba el Cargo del evaluador al momento de la evaluación')
            "
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogEvaluador()">{{
          $t("Cancelar")
        }}</el-button>
        <el-button
          type="primary"
          @click="editEvaluador('formEvaluador')"
          v-if="editingEvaluador"
          >{{ $t("Guardar") }}</el-button
        >
        <el-button
          type="primary"
          @click="addEvaluador('formEvaluador')"
          v-else
          >{{ $t("Agregar") }}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      title="Causa"
      :rules="rules"
      append-to-body
      ref="formCausa"
      :visible="dialogNewCausaVisible"
    >
      <p>
        {{
          $t(`A continuación se presenta un listado con causas predefenidas.
        En el caso que una causa del evento no se encuentre en listado,
        seleccionar la opción \'Otro\' al final del listado y agregarla en
        el recuadro de texto que se desplegara.`)
        }}
      </p>
      <el-select
        v-model="formCausa.nombreTemp"
        :placeholder="$t('Seleccione causa asociada')"
        class="with-help-box full-width"
      >
        <el-option-group
          v-for="group in causasInmediatasComputed"
          :key="group.label"
        >
          <p class="groupLabel">{{ group.label }}</p>
          <el-option
            v-for="item in group.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-option-group>
      </el-select>
      <br />
      <br />
      <div v-if="formCausa.nombreTemp === 'other'">
        <el-input
          v-model="formCausa.nombre"
          class="with-help-box full-width"
          :placeholder="$t('Escriba causa del evento')"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogCausa()">{{ $t("Cancelar") }}</el-button>
        <el-button
          v-if="editingCausa"
          type="primary"
          @click="editCausa('formCausa')"
          >{{ $t("Guardar") }}</el-button
        >
        <el-button v-else type="primary" @click="addCausa('formCausa')">{{
          $t("Agregar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Control Preventivo')"
      append-to-body
      :rules="rules"
      ref="formControlPreventivo"
      :visible="dialogNewControlPreventivoVisible"
    >
      <el-form :model="formControlPreventivo" label-position="top">
        <el-form-item
          :label="$t('Causas asociadas al control preventivo')"
          prop="causa"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formControlPreventivo.causas"
            multiple
            filterable
            class="with-help-box full-width"
            :placeholder="$t('Seleccione causa asociada')"
          >
            <el-option
              v-for="(causa, i) in risk.causas"
              :key="`CAUSA`+ (i + 1)"
              :label="`CA`+ (i + 1)"
              :value="causa.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('Nombre')"
          prop="nombre"
          :label-width="formLabelWidth"
        >
          <el-input
            class="with-help-box"
            v-model="formControlPreventivo.nombre"
            auto-complete="on"
          ></el-input>
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Nombre')"
            width="200"
            trigger="hover"
            :content="
              $t(
                'Escriba el control preventivo. Debe ser breve, claro y preciso.'
              )
            "
          >
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <el-form-item
          :label="
            $t(
              `${
                risk.tipo === 'medioambiente'
                  ? 'Jerarquía de Mitigación'
                  : 'Jerarquía de control'
              }`
            )
          "
          prop="jerarquia"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formControlPreventivo.jerarquiaControl"
            filterable
            class="with-help-box full-width"
            :placeholder="
              $t(
                `${
                  risk.tipo === 'medioambiente'
                    ? 'Seleccione Jerarquía de Mitigación'
                    : 'Seleccione Jerarquía de control'
                }`
              )
            "
          >
            <el-option
              v-for="jerarquia in risk.tipo === 'medioambiente'
                ? jerarquiaMedioambiente
                : jerarquiaSaludSeguridad"
              :key="jerarquia.value"
              :label="jerarquia.value"
              :value="jerarquia.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="risk.impactos.length > 0 && risk.impactos[0]['mfl'] > 3"
          :label="$t('¿Es control crítico?')"
          prop="critico"
          :label-width="formLabelWidth"
        >
          <el-switch
            class="with-help-box"
            v-model="formControlPreventivo.critico"
            active-text="Sí"
            inactive-text="No"
          ></el-switch>
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Control Crítico')"
            width="400"
            trigger="hover"
          >
            {{
              $t(`Son quellos controles que solo o en conjunto con otros
            controles reduce significativamente la probabilidad
            y/o el impacto de los Riesgos estandarizados.`)
            }}
            <br />
            {{
              $t(
                `Puede haber más de un control crítico para un riesgo material.`
              )
            }}
            <br />
            {{
              $t(
                `Elementos a considerar en la determinación de un control crítico:`
              )
            }}
            <ul>
              <li>
                {{
                  $t(`Única barrera/capa de protección disponible para la ocurrencia
                del evento o la exposición al impacto.`)
                }}
              </li>
              <li>
                {{
                  $t(
                    `Se utiliza para prevenir o mitigar múltiples causas/impactos.`
                  )
                }}
              </li>
              <li>{{ $t(`Es independiente de otros controles.`) }}</li>
              <li>
                {{
                  $t(`El control es más alto en la jerarquía de controles que
                otros controles en consideración.`)
                }}
              </li>
              <li>
                {{
                  $t(
                    `Se utiliza para detectar o prevenir que el evento escale.`
                  )
                }}
              </li>
            </ul>
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogControlPreventivo()">{{
          $t("Cancelar")
        }}</el-button>
        <el-button
          type="primary"
          @click="editControlPreventivo('formControlPreventivo')"
          v-if="editingControlPreventivo"
          >{{ $t("Guardar") }}</el-button
        >
        <el-button
          type="primary"
          @click="addControlPreventivo('formControlPreventivo')"
          v-else
          >{{ $t("Agregar") }}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Impacto')"
      :rules="rules"
      append-to-body
      ref="formImpacto"
      :visible="dialogNewImpactoVisible"
    >
      <h4 v-if="risk.tipo === 'medioambiente'">
        {{ $t("DESCRIPCIÓN DEL IMPACTO") }}
      </h4>
      <el-row v-if="risk.tipo === 'medioambiente'">
        <el-col :sm="24">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="Ingrese descripción del impacto"
            v-model="formImpacto.descripcion"
          ></el-input>
        </el-col>
      </el-row>
      <br v-if="risk.tipo === 'medioambiente'" />
      <h4>{{ $t("SELECCIONE VALORES") }}</h4>
      <el-row>
        <el-col :sm="8">
          <el-button @click="dialogSeleccionSeveridadVisible = true">{{
            $t("Seleccione Nivel Severidad Residual")
          }}</el-button>
        </el-col>
        <el-col :sm="8">
          <el-button @click="dialogSeleccionProbabilidadVisible = true">{{
            $t("Seleccione Factor Probabilidad")
          }}</el-button>
        </el-col>
        <el-col :sm="8">
          <el-button @click="dialogSeleccionMFLVisible = true">{{
            $t("Seleccione Nivel Severidad MFL")
          }}</el-button>
        </el-col>
      </el-row>
      <br />
      <h4>{{ $t("INFORMACIÓN") }}</h4>
      <el-row>
        <el-col :sm="12">
          <label>{{ $t("Tipo Impacto") }}</label>
          <p class="info-txt" v-if="formImpacto.categoria">
            {{ formImpacto.categoria }}
          </p>
          <p class="info-txt" v-else>---</p>
          <br />
          <label>{{ $t("Nivel Severidad Residual") }}</label>
          <p class="info-txt" v-if="formImpacto.nivel_severidad">
            {{ formImpacto.nivel_severidad }}
          </p>
          <p class="info-txt" v-else>---</p>
          <br />
          <label>{{ $t("Nivel Severidad MFL") }}</label>
          <p class="info-txt" v-if="formImpacto.mfl">{{ formImpacto.mfl }}</p>
          <p class="info-txt" v-else>---</p>
        </el-col>
        <el-col :sm="12">
          <label>{{ $t("Factor Severidad") }}</label>
          <p class="info-txt" v-if="formImpacto.factor_severidad">
            {{ formImpacto.factor_severidad }}
          </p>
          <p class="info-txt" v-else>---</p>
          <br />
          <label>{{ $t("Factor Probabilidad") }}</label>
          <p class="info-txt" v-if="formImpacto.factor_probabilidad">
            {{ formImpacto.factor_probabilidad }}
          </p>
          <p class="info-txt" v-else>---</p>
          <br />
          <label>RRR</label>
          <p
            class="info-txt"
            v-if="
              formImpacto.factor_severidad && formImpacto.factor_probabilidad
            "
          >
            {{
              (formImpacto.factor_severidad *
                10 *
                (formImpacto.factor_probabilidad * 10)) /
              (10 * 10)
            }}
          </p>
          <p class="info-txt" v-else>---</p>
        </el-col>
        <el-col
          :sm="24"
          v-if="
            formImpacto.nivel_severidad === formImpacto.mfl &&
            formImpacto.nivel_severidad !== '' &&
            formImpacto.mfl !== ''
          "
        >
          <h4>{{ $t("COMENTARIO") }}</h4>
          <p class="info-txt">{{ formImpacto.comentario }}</p>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogImpacto()">{{
          $t("Cancelar")
        }}</el-button>
        <el-button
          type="primary"
          @click="editImpacto('formImpacto')"
          v-if="editingImpacto"
          >{{ $t("Guardar") }}</el-button
        >
        <el-button type="primary" @click="addImpacto('formImpacto')" v-else>{{
          $t("Agregar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Seleccione Nivel de Severidad')"
      append-to-body
      :visible="dialogSeleccionSeveridadVisible"
    >
      <p>
        {{
          $t(
            'Seleccione el "Nivel de Severidad Residual (NSR)" haciendo click sobre alguna de las descripciones que salen dentro de la Tabla. Esta selección resultará en obtener el "Nivel de Severidad" y el "Factor de Severidad". Tener en cuenta que el NSR debe ser menor al MFL (Máxima Pérdida Previsible).'
          )
        }}
      </p>
      <TablaSeveridad :impactType="risk.tipo" :click="seleccionaImpacto" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSeleccionSeveridadVisible = false">{{
          $t("Cancelar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Seleccione Factor de Probabilidad')"
      append-to-body
      :visible="dialogSeleccionProbabilidadVisible"
    >
      <p>
        {{
          $t(
            'Seleccione el "Factor de Probabilidad" haciendo click sobre alguna de las descripciones que salen dentro de la tabla.'
          )
        }}
        <br />
        {{
          $t('Esta selección resultará en obtener el "Factor de Probabilidad".')
        }}
      </p>
      <TablaProbabilidad :click="seleccionaProbabilidad" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSeleccionProbabilidadVisible = false">{{
          $t("Cancelar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Seleccione MFL')"
      append-to-body
      :visible="dialogSeleccionMFLVisible"
    >
      <p>
        {{
          $t(
            'Seleccione el "Nivel de Severidad MFL (Máxima Pérdida Previsible)." haciendo click sobre alguna de las descripciones que salen dentro de la tabla. Esta selección resultará en obtener el "Nivel de Severidad MFL". Tener en cuenta que el MFL debe ser mayor a NSR.'
          )
        }}
      </p>
      <TablaSeveridad :impactType="risk.tipo" :click="seleccionaMFL" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSeleccionMFLVisible = false">{{
          $t("Cancelar")
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Control Mitigador')"
      append-to-body
      :rules="rules"
      ref="formControlMitigador"
      :visible="dialogNewControlMitigadorVisible"
    >
      <el-form :model="formControlMitigador" label-position="top">
        <el-form-item
          :label="$t('Impacto')"
          prop="impacto"
          :label-width="formLabelWidth"
        >
          <el-select
            :disabled="true"
            v-model="formControlMitigador.impacto"
            filterable
            class="with-help-box full-width"
            :placeholder="$t('Seleccione impacto asociado')"
          >
            <el-option
              v-for="impacto in risk.impactos"
              :key="impacto.id"
              :label="impacto.categoria"
              :value="impacto.id"
            />
          </el-select>
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Selección Impacto')"
            width="200"
            trigger="hover"
            :content="
              $t('Listado de impactos asociados al riesgo. Seleccione uno.')
            "
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item
          :label="$t('Nombre')"
          prop="nombre"
          :label-width="formLabelWidth"
        >
          <el-input
            class="with-help-box"
            v-model="formControlMitigador.nombre"
            auto-complete="on"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Nombre')"
            width="200"
            trigger="hover"
            :content="
              $t(
                'Escriba el control mitigador. Debe ser breve, claro y preciso.'
              )
            "
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item
          :label="
            $t(
              `${
                risk.tipo === 'medioambiente'
                  ? 'Jerarquía de Mitigación'
                  : 'Jerarquía de control'
              }`
            )
          "
          prop="jerarquia"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formControlMitigador.jerarquiaControl"
            filterable
            class="with-help-box full-width"
            :placeholder="
              $t(
                `${
                  risk.tipo === 'medioambiente'
                    ? 'Seleccione Jerarquía de Mitigación'
                    : 'Seleccione Jerarquía de control'
                }`
              )
            "
          >
            <el-option
              v-for="jerarquia in risk.tipo === 'medioambiente'
                ? jerarquiaMedioambiente
                : jerarquiaSaludSeguridad"
              :key="jerarquia.value"
              :label="jerarquia.value"
              :value="jerarquia.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="risk.impactos.length > 0 && risk.impactos[0]['mfl'] > 3"
          :label="$t('¿Es control crítico?')"
          prop="critico"
          :label-width="formLabelWidth"
        >
          <el-switch
            class="with-help-box"
            v-model="formControlMitigador.critico"
            active-text="Sí"
            inactive-text="No"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Control Crítico')"
            width="400"
            trigger="hover"
          >
            {{
              $t(`Son quellos controles que solo o en conjunto con otros
            controles reduce significativamente la probabilidad
            y/o el impacto de los Riesgos estandarizados.`)
            }}
            <br />
            {{
              $t(
                `Puede haber más de un control crítico para un riesgo material.`
              )
            }}
            <br />
            {{
              $t(
                `Elementos a considerar en la determinación de un control crítico:`
              )
            }}
            <ul>
              <li>
                {{
                  $t(`Única barrera/capa de protección disponible para la ocurrencia
                del evento o la exposición al impacto.`)
                }}
              </li>
              <li>
                {{
                  $t(
                    `Se utiliza para prevenir o mitigar múltiples causas/impactos.`
                  )
                }}
              </li>
              <li>{{ $t(`Es independiente de otros controles.`) }}</li>
              <li>
                {{
                  $t(`El control es más alto en la jerarquía de controles que
                otros controles en consideración.`)
                }}
              </li>
              <li>
                {{
                  $t(
                    `Se utiliza para detectar o prevenir que el evento escale.`
                  )
                }}
              </li>
            </ul>
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogControlMitigador()">Cancelar</el-button>
        <el-button
          v-if="editingControlMitigador"
          type="primary"
          @click="editControlMitigador('formControlMitigador')"
          >{{ $t("Guardar") }}</el-button
        >
        <el-button
          v-else
          type="primary"
          @click="addControlMitigador('formControlMitigador')"
          >{{ $t("Agregar") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Circle9 } from "vue-loading-spinner";
import { clone } from "lodash";
import Vue from "vue";
import uuid from "uuid/v4";
import axios from "axios";
import TablaSeveridad from "./TablaSeveridad.vue";
import TablaProbabilidad from "./TablaProbabilidad.vue";

export default {
  data() {
    return {
      control_no_critico: "",
      render: 0,
      typeRisk: "",
      searchUser: false,
      inputCargoDisable: true,
      inputNombreDisable: true,
      inputCargoDisable: true,
      dialogNewEvaluadorVisible: false,
      dialogNewCausaVisible: false,
      dialogNewImpactoVisible: false,
      dialogNewControlPreventivoVisible: false,
      dialogNewControlMitigadorVisible: false,
      dialogSeleccionSeveridadVisible: false,
      dialogSeleccionProbabilidadVisible: false,
      dialogSeleccionMFLVisible: false,
      editingCausa: false,
      editingCausaID: null,
      formCausa: {
        nombre: "",
        nombreTemp: "",
      },
      jerarquiaSaludSeguridad: [
        {
          value: "Eliminación",
        },
        {
          value: "Sustitución",
        },
        {
          value: "Controles de ingeniería",
        },
        {
          value: "Controles administrativos",
        },
        {
          value: "Elementos de Protección a las Personas (EPP)",
        },
      ],
      jerarquiaMedioambiente: [
        {
          value: "Evitar",
        },
        {
          value: "Minimizar",
        },
        {
          value: "Rehabilitar Impactos Medioambientales",
        },
      ],
      causasInmediatas: [
        {
          label: "Salud y Seguridad",
          options: [
            { value: "Acción de terceros" },
            { value: "Actuar sin autorización" },
            { value: "Actuar a velocidad anormal" },
            { value: "Conducta / comportamiento inadecuado" },
            { value: "Desviarse de los Métodos /normativas aceptadas" },
            { value: "Intervenir equipos energizados y/o en movimientos" },
            { value: "Mal manejo de materiales, equipos e insumos" },
            { value: "No advertir /señalizar" },
            { value: "No usar equipo de protección personal" },
            { value: "Omitir o neutralizar dispositivos de protección" },
            { value: "Presentarse en condiciones anormales" },
            { value: "Ubicarse en posición o postura incómoda" },
            { value: "Uso de vestuario o elementos extraños" },
            { value: "Uso inadecuado de datos /información" },
            { value: "Uso inadecuado de herramientas y equipos de protección" },
            { value: "Almacenamiento defectuoso" },
            { value: "Área/ Recinto congestionado o restringido" },
            { value: "Equipo de protección fuera de especificación" },
            {
              value:
                "Factores/ condiciones ambientales anormales (Exposiciones al ruido, radiación, falta ventilación / iluminación o temperaturas extremas)",
            },
            { value: "Falta o falla de protecciones / defensas" },
            {
              value:
                "Herramientas / materiales / equipos defectuoso o inapropiado",
            },
            { value: "Identificación y señalización incorrectas" },
            { value: "Método o Procedimiento Peligroso" },
            { value: "Orden y aseo deficientes" },
            { value: "Problemas en sistemas de energías" },
            { value: "Protección y defensas fuera de norma o especificación" },
            { value: "Sistemas de información deficiente" },
            {
              value:
                "Sobrecarga /saturación de sistemas /instalaciones / equipos",
            },
            { value: "Superficie de trabajo dañada / inadecuada" },
            { value: "Vehículo / equipo en mal estado" },
            { value: "Peligro de explosión o incendio" },
          ],
        },
        {
          label: "Medioambiente",
          options: [
            {
              value: "Ausencia de controles",
            },
            {
              value: "Falla de los controles",
            },
            {
              value: "No aplicación de los controles (fisicos)",
            },
            {
              value: "Falla de Materiales",
            },
            {
              value: "Accion de terceros",
            },
            {
              value: "No aplicación de procedimiento",
            },
            {
              value: "Almacenamiento defectuoso",
            },
            {
              value: "aplicación inadecuada de controles",
            },
            {
              value: "Desconocimiento de procedimiento",
            },
            {
              value: "Diseño inadecuado del control",
            },
            {
              value: "actividad no autorizada",
            },
            {
              value: "extraccion  sobre lo autorizado",
            },
            {
              value: "Falta de seguimiento al control ",
            },
            {
              value: "Daño por equipo móvil",
            },
          ],
        },
        {
          label: "Otro",
          options: [
            {
              label: "Otro",
              value: "other",
            },
          ],
        },
      ],
      editingControlPreventivo: false,
      editingControlPreventivoID: null,
      formControlPreventivo: {
        nombre: "",
        critico: false,
        jerarquiaControl: "",
        causas: [],
      },
      editingImpacto: false,
      editingImpactoID: null,
      formImpacto: {
        categoria: "",
        descripcion: "",
        factor_severidad: "",
        factor_probabilidad: "",
        nivel_severidad: "",
        mfl: "",
      },
      editingControlMitigador: false,
      editingControlMitigadorID: null,
      formControlMitigador: {
        nombre: "",
        critico: false,
        jerarquiaControl: "",
        impacto: this.risk.impactos[0],
      },
      editingEvaluador: false,
      editingEvaluadorID: null,
      formEvaluador: {
        id: "",
        nombre: "",
        rut: "",
        cargo: "",
      },
      formLabelWidth: "120px",
      optionsCondicion: [
        { value: "Normal" },
        { value: "Anormal" },
        { value: "Emergencia" },
      ],
      rules: {
        nombre: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur",
          },
          {
            min: 3,
            max: 5,
            message: "Length should be 3 to 5",
            trigger: "blur",
          },
        ],
      },
      rulesEvaluador: {
        rut: [
          {
            required: true,
            message: "Por favor ingrese nombre de usuario",
            trigger: "change",
          },
        ],
        nombre: [
          {
            required: true,
            message: "Por favor ingrese Nombre",
            trigger: "change",
          },
        ],
      },
    };
  },
  components: {
    TablaSeveridad,
    TablaProbabilidad,
    Circle9,
  },
  props: [
    "dataHistory",
    "editable",
    "risk",
    "addCause",
    "deleteCause",
    "editCause",
    "editImpact",
    "addImpact",
    "deleteImpact",
    "addPreventiveControl",
    "editPreventiveControl",
    "deletePreventiveControl",
    "addMitigationControl",
    "deleteMitigationControl",
    "editMitigationControl",
    "addEvaluator",
    "deleteEvaluator",
    "editEvaluator",
    "appendToBody",
  ],
  created() {
    this.typeRisk = this.risk.tipo;
  },
  computed: {
    causasInmediatasComputed() {
      const selected = this.risk.causas.map((r) => r.nombre);
      const options = [];
      this.causasInmediatas.forEach((ci) => {
        const group = { label: ci.label, options: [] };
        ci.options.forEach((o) => {
          if (!selected.includes(o.value)) {
            group.options.push(o);
          } else {
          }
        });
        options.push(group);
      });
      return options;
    },
  },
  watch: {
    "formEvaluador.rut": function () {
      this.debounceInput();
    },
  },
  methods: {
    deleteControlNoCritico(control) {
      this.risk.controles_no_criticos.forEach((c, i) => {
        if (c.id === control.id) {
          this.risk.controles_no_criticos.splice(i, 1);
        }
      });
    },
    addControlNoCritico() {
      var control = {
        id: uuid(),
        nombre: this.control_no_critico,
      };
      this.risk.controles_no_criticos.push(control);
      this.control_no_critico = "";
    },
    debounceInput: _.debounce(function () {
      this.searchUser = true;
      const userExist = this.$store.getters.usersFaena.find(
        (x) => x.rut === this.formEvaluador.rut
      );
      if (userExist) {
        this.formEvaluador = {
          id: userExist._id,
          nombre: `${userExist.nombre} ${userExist.apellido}`,
          rut: userExist.rut,
        };
        this.inputNombreDisable = true;
        this.inputCargoDisable = false;
        this.searchUser = false;
      } else {
        axios
          .get(`/usuarios/by_rut/${this.formEvaluador.rut}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((response) => {
            if (response.data.success !== false) {
              this.formEvaluador.id = response.data._id;
              this.formEvaluador.nombre = `${response.data.nombre} ${response.data.apellido}`;
              this.formEvaluador.rut = response.data.rut;
              this.inputNombreDisable = true;
              this.inputCargoDisable = false;
              this.searchUser = false;
            } else {
              this.inputNombreDisable = false;
              this.inputCargoDisable = false;
              this.formEvaluador.id = "";
              /* this.formEvaluador.nombre = '';
            this.formEvaluador.cargo = ''; */
              this.searchUser = false;
            }
          });
      }
    }, 1500),
    skipControlMitigador(impacto) {
      impacto.forEach((imp) => {
        if (imp.controles_mitigadores && imp.controles_mitigadores.length > 0) {
          this.$confirm(
            this.$t(
              "Esto borrará todos los controles mitigadores registrados. ¿Está seguro que desea continuar?"
            ),
            this.$t("Atención"),
            {
              type: "warning",
            }
          ).then(() => {
            this.risk.impactos[0].controles_mitigadores = [];
            this.addSkipControlMitigador();
          });
        } else {
          this.addSkipControlMitigador();
        }
      });
    },
    addSkipControlMitigador() {
      this.formControlMitigador = {
        nombre: "No Aplica",
        critico: false,
        impacto: this.risk.impactos[0].id,
      };
      const impactIndex = this.risk.impactos.findIndex(
        (impact) => impact.id === this.formControlMitigador.impacto
      );
      if (impactIndex !== -1) {
        if (!this.risk.impactos[impactIndex].controles_mitigadores) {
          Vue.set(this.risk.impactos, impactIndex, {
            ...this.risk.impactos[impactIndex],
            controles_mitigadores: [],
          });
        }
        const controlMitigador = {
          id: uuid(),
          nombre: this.formControlMitigador.nombre,
          critico: this.formControlMitigador.critico,
          jerarquiaControl: this.formControlMitigador.jerarquiaControl,
          not_apply: true,
        };
        this.risk.impactos[impactIndex].controles_mitigadores.push(
          controlMitigador
        );
      }
      this.closeDialogControlMitigador();
    },
    validarControlMitigador(impacto) {
      let visible = false;
      impacto.forEach((imp) => {
        if (imp.controles_mitigadores && imp.controles_mitigadores.length > 0) {
          imp.controles_mitigadores.forEach((mitigador) => {
            if (mitigador.not_apply === true) {
              visible = false;
            } else {
              visible = true;
            }
          });
        } else {
          visible = true;
        }
      });
      return visible;
    },
    setTypeRisk(typeRisk) {
      if (this.risk.tipo === null || this.risk.impactos.length === 0) {
        this.changeType(typeRisk);
      } else {
        this.$confirm(
          "Al cambiar el tipo de impacto se reestablecerá la evaluación del impacto y los riesgos mitigadores ya definidos. ¿Seguro deseas continuar?",
          "Advertencia",
          {
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        )
          .then(() => {
            this.changeType(typeRisk);
            this.risk.impactos = [];
            // this.risk.causas = [];
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Acción cancelada",
            });
          });
      }
    },
    changeType(typeRisk) {
      this.risk.tipo = typeRisk;
      this.typeRisk = typeRisk;
      this.risk.salud = typeRisk === "Salud";
      this.risk.seguridad = typeRisk === "Seguridad";
      if (typeRisk === "Medioambiente") {
        this.risk.medioambiental = true;
        this.risk.medioambiente = {};
      } else {
        this.risk.medioambiental = false;
        this.risk.medioambiente = {};
      }
      if (this.$route.path !== "/admin/riesgos-estandarizados") {
        this.dataHistory.push({
          id_inventory: this.$store.getters.inventario._id,
          action: `Se cambió el tipo del riesgo ${this.risk.nombre} a ${typeRisk}.`,
          user: this.username(),
          date: new Date(),
          type: "update",
        });
      }
      this.render = this.render + 1;
    },
    handleClose() {
      this.dialogNewEvaluadorVisible = false;
      this.dialogNewCausaVisible = false;
      this.dialogNewImpactoVisible = false;
      this.dialogNewControlPreventivoVisible = false;
      this.dialogNewControlMitigadorVisible = false;
      this.dialogSeleccionSeveridadVisible = false;
      this.dialogSeleccionProbabilidadVisible = false;
      this.dialogSeleccionMFLVisible = false;
    },
    getControlesPreventivos(risk) {
      const controlesIndicator = {};
      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const humanID = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach((control) => {
              if (!controlesIndicator[control.nombre]) {
                controlesIndicator[control.nombre] = {};
                controlesIndicator[control.nombre].critico = control.critico;
                controlesIndicator[control.nombre].id = control.id;
                controlesIndicator[control.nombre].jerarquiaControl =
                  control.jerarquiaControl;
              }
              if (!controlesIndicator[control.nombre].causasHumanID) {
                controlesIndicator[control.nombre].causasHumanID = [];
                controlesIndicator[control.nombre].causasID = [];
              }
              controlesIndicator[control.nombre].causasHumanID.push(humanID);
              controlesIndicator[control.nombre].causasID.push(causa.id);
            });
          }
        });
      }
      const controles = Object.keys(controlesIndicator).map((key) => ({
        causasHumanID: controlesIndicator[key].causasHumanID,
        causasID: controlesIndicator[key].causasID,
        nombre: key,
        critico: controlesIndicator[key].critico,
        id: controlesIndicator[key].id,
        jerarquiaControl: controlesIndicator[key].jerarquiaControl,
      }));
      return controles;
    },
    getControlesMitigadores(risk) {
      const controles = [];
      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;
          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach((control) => {
              control.id_impacto = id;
              control.impactoId = impacto.id;
              controles.push(control);
            });
          }
        });
      }
      return controles;
    },
    getFactores(risk) {
      let mfl = 0;
      let rrr = 0;
      if (risk.impactos) {
        risk.impactos.forEach((impacto) => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr =
              (impacto.factor_severidad *
                10 *
                (impacto.factor_probabilidad * 10)) /
              (10 * 10);
          }
        });
      }
      return [
        {
          mfl,
          rrr,
        },
      ];
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    },
    tablaControlCritico(row, index) {
      if (row.critico) {
        return "control-critico";
      }
    },
    addCausa(formName) {
      let causa = this.formCausa.nombre;
      if (this.formCausa.nombreTemp !== "other") {
        causa = this.formCausa.nombreTemp;
      }
      if (!causa) {
        this.$message({
          message: this.$t("Debes seleccionar o escribir una causa"),
          type: "error",
        });
        return;
      }
      this.addCause(causa);
      this.closeDialogCausa();
    },
    closeDialogCausa() {
      this.editingCausa = false;
      this.editingCausaID = null;
      this.formCausa.nombre = "";
      this.formCausa.nombreTemp = "";
      this.dialogNewCausaVisible = false;
    },
    addImpacto(formName) {
      if (
        this.formImpacto.factor_severidad &&
        this.formImpacto.factor_probabilidad &&
        this.formImpacto.mfl
      ) {
        this.addImpact(this.formImpacto);
      }
      this.closeDialogImpacto();
    },
    closeDialogImpacto() {
      this.editingImpacto = false;
      this.editingImpactoID = null;
      this.formImpacto.factor_severidad = "";
      this.formImpacto.nivel_severidad = "";
      this.formImpacto.factor_probabilidad = "";
      this.formImpacto.categoria = "";
      this.formImpacto.descripcion = "";
      this.formImpacto.mfl = "";
      this.formImpacto.comentario = "";
      this.dialogNewImpactoVisible = false;
    },
    seleccionaImpacto(impacto) {
      this.formImpacto.mfl = "";
      this.formImpacto.factor_severidad = "";
      this.formImpacto.factor_probabilidad = "";
      this.formImpacto.comentario = "";
      if (this.formImpacto.mfl) {
        if (impacto.nivelSeveridad > this.formImpacto.mfl) {
          this.$alert(
            `${this.$t(
              "Tu Nivel de Severidad Residual debe ser menor o igual al MFL"
            )} (${this.formImpacto.mfl})`,
            this.$t("Atención"),
            { type: "error" }
          );
          return;
        }
        if (impacto.nivelSeveridad !== this.formImpacto.mfl) {
          this.formImpacto.comentario = "";
        }
        if (impacto.nivelSeveridad === this.formImpacto.mfl) {
          this.$prompt(
            "Su nivel de severidad residual es igual al nivel de severidad MFL, debido a esto debe ingresar un comentario explicando las razones.",
            "Ingrese comentario",
            {
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar",
              inputType: "textarea",
              inputErrorMessage: "Comentario invalido",
            }
          ).then(({ value }) => {
            this.$message({
              type: "success",
              message: "Comentario ingresado con exito",
            });
            this.formImpacto.comentario = value;
            this.formImpacto.nivel_severidad = impacto.nivelSeveridad;
            this.formImpacto.factor_severidad = impacto.factorSeveridad;
            // Setear severidad por tipo de impacto
            if (this.risk.tipo === "salud") {
              this.formImpacto.categoria = "Salud";
            } else if (this.risk.tipo === "seguridad") {
              this.formImpacto.categoria = "Seguridad";
            } else if (
              this.risk.tipo === "medioambiental" ||
              this.risk.tipo === "medioambiente"
            ) {
              this.formImpacto.categoria = "Medioambiente";
            }
            this.dialogSeleccionSeveridadVisible = false;
          });
          return;
        }
      }
      this.formImpacto.nivel_severidad = impacto.nivelSeveridad;
      this.formImpacto.factor_severidad = impacto.factorSeveridad;
      // Setear severidad por tipo de impacto
      if (this.risk.tipo === "salud") {
        this.formImpacto.categoria = "Salud";
      } else if (this.risk.tipo === "seguridad") {
        this.formImpacto.categoria = "Seguridad";
      } else if (
        this.risk.tipo === "medioambiental" ||
        this.risk.tipo === "medioambiente"
      ) {
        this.formImpacto.categoria = "Medioambiente";
      }
      this.dialogSeleccionSeveridadVisible = false;
    },
    seleccionaMFL(impacto, tipo) {
      if (this.formImpacto.nivel_severidad) {
        if (impacto.nivelSeveridad < this.formImpacto.nivel_severidad) {
          this.$alert(
            `${this.$t(
              "Tu MFL debe ser mayor o igual al Nivel de Severidad Residual"
            )} (${this.formImpacto.nivel_severidad})`,
            this.$t("Atención"),
            { type: "error" }
          );
          return;
        }
        if (impacto.nivelSeveridad === this.formImpacto.nivel_severidad) {
          this.$prompt(
            "Atención MFL y Nivel de severidad son iguales, debido a esto debe ingresar un comentario explicando las razones.",
            "Ingrese comentario",
            {
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar",
              inputType: "textarea",
              inputErrorMessage: "Comentario invalido",
            }
          ).then(({ value }) => {
            this.$message({
              type: "success",
              message: "Comentario ingresado con exito",
            });
            this.formImpacto.comentario = value;
            this.formImpacto.mfl = impacto.nivelSeveridad;
            this.dialogSeleccionMFLVisible = false;
          });
          return;
        }
      }
      this.formImpacto.comentario = "";
      this.formImpacto.mfl = impacto.nivelSeveridad;
      this.dialogSeleccionMFLVisible = false;
    },
    seleccionaProbabilidad(probabilidad) {
      this.formImpacto.factor_probabilidad = probabilidad;
      this.dialogSeleccionProbabilidadVisible = false;
    },
    addControlPreventivo(formName) {
      const control = clone(this.formControlPreventivo);
      if (control.nombre && control.causas.length > 0) {
        const controlPreventivo = {
          id: uuid(),
          nombre: control.nombre,
          critico: control.critico,
          jerarquiaControl: control.jerarquiaControl,
        };
        var causeIndex = 0;
        control.causas.forEach((c) => {
          this.risk.causas.forEach((rc, index) => {
            if (rc.id === c) {
              if (!rc.controles_preventivos) {
                rc["controles_preventivos"] = [];
              }
              causeIndex = index;
              rc.controles_preventivos.push(controlPreventivo);
            }
          });
        });

        if (this.$route.path !== "/admin/riesgos-estandarizados") {
          this.dataHistory.push({
            id_inventory: this.$store.getters.inventario._id,
            action: `Se agregó el control preventivo ${controlPreventivo.nombre} a la causa ${this.risk.causas[causeIndex].nombre}. del riesgo ${this.risk.nombre}`,
            user: this.username(),
            date: new Date(),
            type: "add",
          });
        }
        this.closeDialogControlPreventivo();
      } else {
        this.$alert(`Para continuar debe completar todos los campos solicitados`, 'Información', {
          confirmButtonText: 'Aceptar',
        });
      }
    },
    closeDialogControlPreventivo() {
      this.editingControlPreventivo = false;
      this.editingControlPreventivoID = null;
      this.formControlPreventivo.nombre = "";
      this.formControlPreventivo.critico = false;
      this.formControlPreventivo.causas = [];
      this.formControlPreventivo.jerarquiaControl = "";
      this.dialogNewControlPreventivoVisible = false;
    },
    username() {
      return `${this.$store.getters.user.nombre} ${this.$store.getters.user.apellido}`;
    },
    addControlMitigador(formName) {
      const control = clone(this.formControlMitigador);
      if (control.nombre && control.impacto) {
        const control = clone(this.formControlMitigador);
        if (!this.risk.impactos[0].controles_mitigadores) {
          Vue.set(this.risk.impactos, 0, {
            ...this.risk.impactos[0],
            controles_mitigadores: [],
          });
        }
        const controlMitigador = {
          id: uuid(),
          nombre: control.nombre,
          critico: control.critico,
          jerarquiaControl: control.jerarquiaControl,
          not_apply: false,
        };
        this.risk.impactos[0].controles_mitigadores.push(controlMitigador);
        if (this.$route.path !== '/admin/riesgos-estandarizados') {
          this.dataHistory.push({
            id_inventory: this.$store.getters.inventario._id,
            action: `Se agregó el control mitigador ${controlMitigador.nombre} al impacto de tipo ${this.risk.impactos[0].categoria}.`,
            user: this.username(),
            date: new Date(),
            type: 'add',
          });
        }
      } else {
      }
      this.closeDialogControlMitigador();
    },
    closeDialogControlMitigador() {
      this.editingControlMitigador = false;
      this.editingControlMitigadorID = null;
      this.formControlMitigador.nombre = "";
      this.formControlMitigador.critico = false;
      this.formControlMitigador.impacto = this.risk.impactos[0];
      this.formControlMitigador.jerarquiaControl = "";
      this.dialogNewControlMitigadorVisible = false;
    },
    openDialogControlMitigador() {
      this.formControlMitigador.impacto = this.risk.impactos[0];
      this.dialogNewControlMitigadorVisible = true;
    },
    deleteCausa(cause) {
      this.$confirm(
        this.$t(
          "Esto borrará la causa y todos sus controles asociados. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        this.deleteCause(cause.id);
      });
    },
    deleteImpacto(impact) {
      this.$confirm(
        this.$t(
          "Esto borrará el impacto y todos sus controles asociados. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        this.deleteImpact(impact.id);
      });
    },
    deleteControlPreventivo(control) {
      this.$confirm(
        this.$t(
          "Esto borrará el control preventivo. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        this.risk.causas.forEach((cause, causeIndex) => {
          if (cause.controles_preventivos) {
            cause.controles_preventivos.forEach((cp, cp_index) => {
              if (cp.id === control.id) {
                if (this.$route.path !== "/admin/riesgos-estandarizados") {
                  this.dataHistory.push({
                    id_inventory: this.$store.getters.inventario._id,
                    action: `Se eliminó el control preventivo ${this.risk.causas[causeIndex].controles_preventivos[cp_index].nombre} del riesgo ${this.risk.nombre}.`,
                    user: this.username(),
                    date: new Date(),
                    type: "delete",
                  });
                }
                cause.controles_preventivos.splice(cp_index, 1);
                this.render = this.render + 1;
              }
            });
          }
        });
      });
    },
    deleteControlMitigador(control) {
      this.$confirm(
        this.$t(
          "Esto borrará el control mitigador. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        this.deleteMitigationControl(control.impactoId, control.id);
      });
    },
    editDialogControlMitigador(control) {
      this.formControlMitigador = {
        nombre: control.nombre,
        critico: control.critico,
        impacto: control.impactoId,
        jerarquiaControl: control.jerarquiaControl,
      };
      this.editingControlMitigador = true;
      this.editingControlMitigadorID = control.id;
      this.dialogNewControlMitigadorVisible = true;
    },
    editDialogCausa(causa) {
      this.formCausa = {
        nombre: "",
        nombreTemp: "",
      };
      let isOnList = false;
      for (const index in this.causasInmediatas) {
        for (let i = 0; i < this.causasInmediatas[index].options.length; i++) {
          const causaPredefinida = this.causasInmediatas[index].options[i]
            .value;
          if (causaPredefinida === causa.nombre) {
            isOnList = true;
          }
        }
      }
      if (!isOnList) {
        this.formCausa.nombreTemp = "other";
        this.formCausa.nombre = causa.nombre;
      } else {
        this.formCausa.nombreTemp = causa.nombre;
      }
      this.editingCausa = true;
      this.editingCausaID = causa.id;
      this.dialogNewCausaVisible = true;
    },
    editCausa(formCausa) {
      let causa = this.formCausa.nombre;
      if (this.formCausa.nombreTemp !== "other") {
        causa = this.formCausa.nombreTemp;
      }
      if (!causa) {
        this.$message({
          message: this.$t("Debes seleccionar o escribir una causa"),
          type: "error",
        });
        return;
      }
      this.editCause(causa, this.editingCausaID);
      this.closeDialogCausa();
    },
    editDialogImpacto(impacto) {
      this.formImpacto = {
        categoria: impacto.categoria,
        descripcion: impacto.descripcion,
        comentario: impacto.comentario,
        factor_severidad: impacto.factor_severidad,
        factor_probabilidad: impacto.factor_probabilidad,
        nivel_severidad: impacto.nivel_severidad,
        mfl: impacto.mfl,
      };
      this.editingImpacto = true;
      this.editingImpactoID = impacto.id;
      this.dialogNewImpactoVisible = true;
    },
    editImpacto(formImpacto) {
      if (
        this.formImpacto.factor_severidad &&
        this.formImpacto.factor_probabilidad &&
        this.formImpacto.mfl
      ) {
        this.editImpact(this.formImpacto, this.editingImpactoID);
      }
      this.closeDialogImpacto();
    },
    editDialogControlPreventivo(control) {
      this.formControlPreventivo = {
        nombre: control.nombre,
        critico: control.critico,
        causas: control.causasID,
        jerarquiaControl: control.jerarquiaControl,
      };
      this.editingControlPreventivo = true;
      this.editingControlPreventivoID = control.id;
      this.dialogNewControlPreventivoVisible = true;
    },
    editControlPreventivo(formControl) {
      const control = clone(this.formControlPreventivo);
      //
      const { risk } = this;
      risk.causas.forEach((cause, causeIndex) => {
        // Se busca si esta causa ya tiene este control asignado
        let controlIndex = -1;
        if (cause.controles_preventivos) {
          controlIndex = cause.controles_preventivos.findIndex(
            (control) => control.id === this.editingControlPreventivoID
          );
        }

        // El control editado, tiene asociada esta causa?
        if (control.causas.includes(cause.id)) {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            const oldValue = JSON.parse(
              JSON.stringify(cause.controles_preventivos[controlIndex])
            );
            Vue.set(cause.controles_preventivos, controlIndex, {
              ...cause.controles_preventivos[controlIndex],
              nombre: control.nombre,
              critico: control.critico,
              jerarquiaControl: control.jerarquiaControl,
            });
            if (this.$route.path !== "/admin/riesgos-estandarizados") {
              this.dataHistory.push({
                id_inventory: this.$store.getters.inventario._id,
                action: `Se modificó el control preventivo ${
                  oldValue.nombre
                }, ( Nombre: ${control.nombre}, Critico: ${
                  control.critico === true ? "Si" : "No"
                }, Jerarquía de control: ${control.jerarquiaControl} ).`,
                user: this.username(),
                date: new Date(),
                type: "update",
              });
            }
          } else {
            // Agregar control a causa

            /* CORREGIR */
            if (!cause.controles_preventivos) {
              cause["controles_preventivos"] = [];
            }
            const controlPreventivo = {
              id: this.editingControlPreventivoID,
              nombre: control.nombre,
              critico: control.critico,
              jerarquiaControl: control.jerarquiaControl,
            };
            cause.controles_preventivos.push(controlPreventivo);
            if (this.$route.path !== "/admin/riesgos-estandarizados") {
              this.dataHistory.push({
                id_inventory: this.$store.getters.inventario._id,
                action: `Se agregó el control preventivo ${control.nombre} a la causa ${this.risk.causas[causeIndex].nombre}. del riesgo ${this.risk.nombre}`,
                user: this.username(),
                date: new Date(),
                type: "add",
              });
            }
          }
          // El control editado no tiene esta causa asociada actualmente
        } else {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            // Entonces se borra
            Vue.delete(cause.controles_preventivos, controlIndex);
          }
        }
      });
      this.closeDialogControlPreventivo();
    },
    editControlMitigador(formControl) {
      const control = clone(this.formControlMitigador);
      if (control.nombre && control.impacto) {
        this.risk.impactos.forEach((impact, impactIndex) => {
          // Se busca si este impacto ya tiene este control asignado
          let controlIndex = -1;
          if (impact.controles_mitigadores) {
            controlIndex = impact.controles_mitigadores.findIndex(
              (control) => control.id === this.editingControlMitigadorID
            );
          }

          // El control editado, tiene asociada este impacto?
          if (control.impacto === impact.id) {
            // Este control ya existe en el impacto?
            if (controlIndex >= 0) {
              const oldValue = JSON.parse(
                JSON.stringify(
                  this.risk.impactos[impactIndex].controles_mitigadores[
                    controlIndex
                  ]
                )
              );
              Vue.set(
                this.risk.impactos[impactIndex].controles_mitigadores,
                controlIndex,
                {
                  ...this.risk.impactos[impactIndex].controles_mitigadores[
                    controlIndex
                  ],
                  nombre: control.nombre,
                  critico: control.critico,
                  jerarquiaControl: control.jerarquiaControl,
                }
              );
              if (this.$route.path !== "/admin/riesgos-estandarizados") {
                this.dataHistory.push({
                  id_inventory: this.$store.getters.inventario._id,
                  action: `Se modificó el control mitigador ${
                    oldValue.nombre
                  }, ( Nombre: ${control.nombre}, Critico: ${
                    control.critico === true ? "Si" : "No"
                  }, Jerarquía de control: ${control.jerarquiaControl} ).`,
                  user: this.username(),
                  date: new Date(),
                  type: "update",
                });
              }
            } else {
              // Agregar control a impacto
              if (!impact.controles_mitigadores) {
                impact.controles_mitigadores = [];
              }
              const controlMitigador = {
                id: this.editingControlMitigadorID,
                nombre: control.nombre,
                critico: control.critico,
                jerarquiaControl: control.jerarquiaControl,
              };
              impact.controles_mitigadores.push(controlMitigador);
            }
            // El control editado no tiene este impacto asociada actualmente
          } else {
            // Este control ya existe en el impacto?
            if (controlIndex >= 0) {
              // Entonces se borra
              Vue.delete(
                this.risk.impactos[impactIndex].controles_mitigadores,
                controlIndex
              );
            }
          }
        });
      }
      this.closeDialogControlMitigador();
    },
    closeDialogEvaluador() {
      this.editingEvaluador = false;
      this.editingEvaluadorID = null;
      this.formEvaluador = {
        id: "",
        nombre: "",
        rut: "",
        cargo: "",
      };
      this.dialogNewEvaluadorVisible = false;
    },
    editDialogEvaluador(evaluador) {
      this.formEvaluador = {
        nombre: evaluador.nombre,
        cargo: evaluador.cargo,
        rut: evaluador.rut,
        empresa: evaluador.empresa,
      };
      this.editingEvaluador = true;
      this.editingEvaluadorID = evaluador.id;
      this.dialogNewEvaluadorVisible = true;
    },
    deleteEvaluador(evaluador) {
      this.$confirm(
        this.$t("Esto borrará el evaluador. ¿Está seguro que desea continuar?"),
        this.$t("Atención"),
        {
          type: "warning",
        }
      ).then(() => {
        this.deleteEvaluator(evaluador.id);
      });
    },
    editEvaluador(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.editEvaluator(this.formEvaluador, this.editingEvaluadorID);
          this.closeDialogEvaluador();
          return;
        }
        return false;
      });
    },
    addEvaluador(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.addEvaluator(this.formEvaluador);
          this.closeDialogEvaluador();
          return;
        }
        return false;
      });
    },
  },
};
</script>

<style scoped>
.btn-bowtie {
  margin-top: 10px;
}
h4 {
  font-weight: bold;
}
label {
  text-transform: uppercase;
  font-weight: bold;
  color: gray;
  font-size: 11px;
}
.info-txt {
  margin-top: 5px;
  color: #e65400;
}
.factores {
  font-size: 20px;
}
.align-right {
  text-align: right;
}
.align-center {
  text-align: center;
}

.button-skip {
  margin-left: 10px;
}
.derecha {
  float: right;
}
.izquierda {
  float: left;
}
.margin-title {
  margin-top: 0px;
}
.groupLabel {
  font-size: 15px;
  font-weight: bold;
  margin-left: 19px;
}
</style>
